module.exports = "<div [ngClass]=\"{'geo-input--error': (!model.id && isRequired && submitted)}\" style=\"margin-top: 0;\">\n    <label>{{label}} <abbr *ngIf=\"isRequired\">*</abbr></label>\n    <div class=\"containerSelect\">\n        <span class=\"error-alert\" *ngIf=\"(!model.id && isRequired && submitted)\">Este campo é obrigatório.</span>\n        <select class=\"select2\" [(ngModel)]=\"model\" ></select>\n        <spinner-component *ngIf=\"loading\"></spinner-component>\n    </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/shared/components/autocomplete-insert/autocomplete-insert.component.html
 ** module id = 120
 ** module chunks = 0
 **/